import React from 'react';
import Input from 'components/Input';

export default function AddCredit({step}) {

  // function getForm() {
  //   switch (step) {
  //     case 0:
  //       return (
  //         <Input 
  //           name="amount"
  //           label="Amount"
  //           placeholder="Eg. 499"
  //           type="number"
  //           variant="filled"
  //         />
  //       )

  //     case 1:
  //       return (
  //         <Input 
  //           name="pin"
  //           label="PIN"
  //           placeholder="Enter your PIN"
  //           type="number"
  //           variant="filled"
  //         />
  //       )
    
  //     default:
  //       return <></>
  //   }
  // }

  return (
    <div className="py-5">
      <Input 
        name="amount"
        label="Amount"
        placeholder="Eg. 499"
        type="number"
        variant="filled"
      />
    </div>
  )
}
